import type { WorkspaceWelcomeScreenConfig } from "@/types/workspaceWelcome";

type WelcomeUserLike = {
  permissions?: string[] | null;
  welcome_screen?: WorkspaceWelcomeScreenConfig | null;
};

const WELCOME_SCREEN_PERMISSION = "home:welcome_screen";

const DEFAULT_WELCOME: WorkspaceWelcomeScreenConfig = {
  enabled: true,
  body: "We have three client cases for you to review.",
  steps: ["Review Letters", "Edit & Approve", "Review Addendums"],
};

export function resolveWorkspaceWelcomeConfig(
  user: WelcomeUserLike | null | undefined,
): WorkspaceWelcomeScreenConfig | null {
  const configured = user?.welcome_screen;
  if (configured?.enabled) {
    const configuredSteps =
      configured.steps
        ?.filter((step) => step.trim().length > 0)
        .map((step) => step.trim()) ?? [];
    return {
      enabled: true,
      body: configured.body?.trim() || DEFAULT_WELCOME.body,
      steps:
        configuredSteps.length > 0 ? configuredSteps : DEFAULT_WELCOME.steps,
    };
  }

  const permissions = user?.permissions ?? [];
  if (permissions.includes(WELCOME_SCREEN_PERMISSION)) {
    return DEFAULT_WELCOME;
  }

  return null;
}

export function isWorkspaceWelcomeEnabled(user: WelcomeUserLike | null | undefined): boolean {
  return resolveWorkspaceWelcomeConfig(user) !== null;
}
